<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row dense class="ma-2">
        <v-col cols="12" md="5">
          <v-card>
            <v-card-title>
              <span class="subtitle-1">
                {{
                  $t(
                    "DistributionUsers.DistributionShopFileds.alternative_shop"
                  )
                }}
              </span>
              <v-spacer />
              <v-btn
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="add()"
              >
                <v-icon x-small class="pe-1" color="white"
                  >fa-angle-double-right</v-icon
                >
                {{ $t("DistributionUsers.DistributionShopFileds.addAll") }}
              </v-btn>
            </v-card-title>
            <v-data-table
              :headers="unselectHeaders"
              :items="unselectShops"
              :loading="loading"
              :search="unselectFilter"
              multi-sort
              class="elevation-2 px-4 py-1 mb-4"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n2 mx-n4">
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="unselectFilter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                    <v-spacer />
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.actions="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click.stop="add(item)"
                      class="px-2 me-2 mb-1"
                    >
                      <v-icon x-small color="white">fa-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("DistributionUsers.DistributionShopFileds.addHint") }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="7">
          <v-card>
            <v-card-title>
              <span class="subtitle-1">
                {{
                  $t(
                    "DistributionUsers.DistributionShopFileds.distribution_shop"
                  )
                }}
              </span>
              <v-spacer />
              <v-btn
                small
                dark
                color="danger"
                class="px-2 me-2 mb-1"
                @click.stop="remove()"
              >
                <v-icon x-small class="pe-1" color="white"
                  >fa-angle-double-left</v-icon
                >
                {{ $t("DistributionUsers.DistributionShopFileds.removeAll") }}
              </v-btn>
            </v-card-title>
            <v-data-table
              :headers="selectedHeaders"
              :items="selectedShops"
              :loading="loading"
              :search="selectedFilter"
              multi-sort
              class="elevation-2 px-4 py-1 mb-4"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n2 mx-n4">
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="selectedFilter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                    <v-spacer />
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.actions="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:item.count_invalid="{ item }">
                <v-chip
                  small
                  label
                  color="warning"
                  text-color="white"
                  @click.stop="
                    $router.push({
                      path: '/stocks/distribution-coverage/invalid-materials',
                      query: {
                        stock_id: stockId,
                        district_code: item.district_code,
                      },
                    })
                  "
                >
                  {{
                    $t("DistributionCoverage.Fields.exclude_materials", [
                      item.count_invalid,
                    ])
                  }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      color="danger"
                      @click.stop="remove(item)"
                      class="px-2 me-2 mb-1"
                    >
                      <v-icon x-small color="white">fa-minus</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $t("DistributionUsers.DistributionShopFileds.removeHint")
                  }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import DistributionUsers from "@/api/distribution_users";

export default {
  components: {
    Breadcrumbs,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("DistributionUsers.title"),
          disabled: false,
          href:
            "/stocks/distribution-users?stock_id=" +
            this.$route.query.stock_id,
        },
        {
          text: i18n.t("distributionStores.ObjectName"),
          disabled: true,
          href: "/stocks-containers",
        },
        {
          text:
            this.distributionUser && this.distributionUser.name
              ? this.distributionUser.name
              : "",
          accent: true,
          disabled: false,
        },
      ];
    },
    unselectHeaders() {
      return [
        {
          text: i18n.t("DistributionUsers.DistributionShopFileds.shop_code", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("DistributionUsers.DistributionShopFileds.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t(
            "DistributionUsers.DistributionShopFileds.shop_district",
            [this.$consts.shopName()]
          ),
          align: "start",
          sortable: false,
          value: "district_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    selectedHeaders() {
      return [
        {
          text: i18n.t("DistributionUsers.DistributionShopFileds.shop_code", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("DistributionUsers.DistributionShopFileds.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t(
            "DistributionUsers.DistributionShopFileds.shop_district",
            [this.$consts.shopName()]
          ),
          align: "start",
          sortable: false,
          value: "district_name",
        },
        {
          text: i18n.t("DistributionUsers.DistributionShopFileds.sort", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "distribution_user_shop.order_flg",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "loading"]),
  },

  data: () => ({
    unselectShops: [],
    selectedShops: [],
    distributionUser: {},
    unselectFilter: "",
    selectedFilter: "",
  }),

  mounted() {
    this.getDistributionUserShopsFromAPI();
  },

  methods: {
    getDistributionUserShopsFromAPI() {
      DistributionUsers.selectShops({
        distribution_user_id: this.$route.params.id,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distributionUser = response.data.distribution_user;
            this.unselectShops = response.data.shops;

            DistributionUsers.selectShops({
              distribution_user_id: this.$route.params.id,
              seletct_flg: 1,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.selectedShops = response.data.shops;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    add(shop) {
      DistributionUsers.addShops({
        distribution_user_id: this.$route.params.id,
        shop_id: shop ? shop.id : "",
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDistributionUserShopsFromAPI();
          }
        }.bind(this)
      );
    },
    remove(shop) {
      DistributionUsers.removeShops({
        distribution_user_id: this.$route.params.id,
        shop_id: shop ? shop.id : "",
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDistributionUserShopsFromAPI();
          }
        }.bind(this)
      );
    },
  },
};
</script>